import React, { useCallback, useEffect, useState } from 'react';
import { adminApi } from '@/lib/api';
import { toast } from 'sonner';
import { Panel } from '@/components/enterprise/ui';

const STATUSES = [
  { key: 'operational', label: 'Betriebsbereit', color: '#2EF2A5' },
  { key: 'degraded', label: 'Eingeschränkt', color: '#FFCC66' },
  { key: 'maintenance', label: 'Wartung', color: '#5AF3FF' },
  { key: 'outage', label: 'Störung', color: '#FF5C7A' },
];

export default function StatusPanel() {
  const [services, setServices] = useState([]);
  const [incTitle, setIncTitle] = useState('');
  const [incMsg, setIncMsg] = useState('');

  const load = useCallback(() => { adminApi.get('/admin/status/services').then((r) => setServices(r.data.services || [])).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const setStatus = async (svc, status) => {
    try {
      await adminApi.patch(`/admin/status/services/${svc.id}`, { status });
      setServices((s) => s.map((x) => (x.id === svc.id ? { ...x, status } : x)));
      toast.success(`${svc.name}: ${status}`);
    } catch (e) { toast.error('Fehler'); }
  };

  const publishIncident = async () => {
    if (!incTitle) { toast.error('Titel erforderlich'); return; }
    try {
      await adminApi.post('/admin/status/incidents', { title: incTitle, message: incMsg, status: 'investigating' });
      setIncTitle(''); setIncMsg('');
      toast.success('Incident veröffentlicht');
    } catch (e) { toast.error('Fehler'); }
  };

  return (
    <div className="space-y-4">
      <Panel title="Service-Status" subtitle="öffentliche Statusseite steuern (nur generische Status)" testid="admin-status-panel">
        <div className="space-y-2">
          {services.map((svc) => (
            <div key={svc.id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-[color:var(--itw-border)] px-3 py-2.5" data-testid={`status-service-${svc.key}`}>
              <div><div className="text-sm text-[color:var(--itw-text)]">{svc.name}</div><div className="text-[11px] text-[color:var(--itw-text-3)] font-mono">{svc.category}</div></div>
              <div className="flex flex-wrap gap-1">
                {STATUSES.map((st) => (
                  <button key={st.key} onClick={() => setStatus(svc, st.key)} data-testid={`status-set-${svc.key}-${st.key}`}
                    className="px-2.5 py-1 text-[11px] rounded-lg border transition-colors"
                    style={svc.status === st.key ? { borderColor: st.color, color: st.color, background: `${st.color}14` } : { borderColor: 'var(--itw-border)', color: 'var(--itw-text-3)' }}>{st.label}</button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Panel>

      <Panel title="Incident veröffentlichen" subtitle="erscheint sofort auf der öffentlichen Statusseite" testid="admin-incident-panel">
        <div className="space-y-2">
          <input value={incTitle} onChange={(e) => setIncTitle(e.target.value)} placeholder="Titel" className="w-full h-9 rounded-lg bg-[color:var(--itw-surface-2)] border border-[color:var(--itw-border)] px-3 text-sm text-[color:var(--itw-text)] outline-none" data-testid="incident-title" />
          <textarea value={incMsg} onChange={(e) => setIncMsg(e.target.value)} placeholder="Beschreibung (optional)" rows={2} className="w-full rounded-lg bg-[color:var(--itw-surface-2)] border border-[color:var(--itw-border)] px-3 py-2 text-sm text-[color:var(--itw-text)] outline-none" data-testid="incident-message" />
          <button onClick={publishIncident} className="px-4 py-2 text-sm rounded-lg bg-[color:var(--itw-cyan)] text-[color:var(--itw-bg)] font-medium" data-testid="incident-publish">Veröffentlichen</button>
        </div>
      </Panel>
    </div>
  );
}
